<template>
	<div class="row height" :class="changeContainerHeight">
		<div class="col-12 q-px-lg container-login">
			<div class="row" v-if="$q.platform.is.desktop">
				<div class="col-12">
					<client-logo />
				</div>

				<div class="col-12 title">
					<div>
						<q-btn flat round icon="fal fa-chevron-left" @click="backButton()" />
					</div>
					<div class="text-grey-10 text-weight-bold text-h6">
						{{ $t('enter_your_new_password') }}
					</div>
					<div></div>
				</div>
			</div>

			<div class="row q-col-gutter-md q-mb-lg" v-if="$q.platform.is.mobile">
				<div class="col-12">
					<client-logo />
				</div>

				<div class="col-1">
					<q-btn icon="fal fa-chevron-left" flat round dense @click="backButton()" />
				</div>

				<div class="col-11 text-h5 text-weight-bold text-center">
					{{ $t('enter_your_new_password') }}
				</div>
			</div>

			<div class="row" :class="$q.platform.is.desktop ? 'full-height relative-position' : ''">
				<div
					class="col-12"
					:class="$q.platform.is.desktop ? 'absolute-center text-center' : ''"
				>
					<div class="row justify-center q-col-gutter-md">
						<div class="col-12">
							{{ $t('enter_a_new_password') }}
						</div>

						<div class="col-xs-12 col-md-7">
							<q-form @submit.prevent="setNewPassword()">
								<div class="row">
									<div class="col-12">
										<q-input
											lower-case
											dense
											v-model="new_password"
											type="password"
											:label="$t('password')"
											:error="v$.new_password.$error"
											@input="v$.new_password.$touch"
										>
											<template v-slot:hint>
												{{ passwordHint }}
											</template>

											<template v-slot:error>
												{{ passwordHint }}
											</template>
										</q-input>
									</div>

									<div class="col-12 q-mt-md">
										<q-input
											lower-case
											dense
											v-model="confirm_password"
											type="password"
											:label="$t('confirm_password')"
											:error="v$.confirm_password.$error"
											@input="v$.confirm_password.$touch"
										/>
									</div>

									<div class="col-12">
										<q-btn
											type="submit"
											color="primary"
											:label="$t('set_new_password')"
											:class="$q.platform.is.mobile ? 'full-width' : ''"
										/>
									</div>
								</div>
							</q-form>
						</div>
					</div>
				</div>
			</div>
		</div>

		<login-form v-show="false" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import LoginForm from 'components/login/LoginForm'
import ClientLogo from 'components/utils/ClientLogo'
import { required, sameAs } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import { axios } from 'src/boot/axios'

export default {
	name: 'SetPassword',

	setup() {
		return { v$: useVuelidate({ $scope: false }) }
	},

	data() {
		return {
			confirm_password: '',
			new_password: '',
			token: '',
			uidb64: '',
			username: '',
			config: null
		}
	},

	components: {
		'login-form': LoginForm,
		'client-logo': ClientLogo,
	},

	computed: {
		...mapGetters({
			id_user_language_selected: 'common/id_user_language_selected',
			languages: 'params/languages',
		}),
		password_strong_level() {
			return this.config.register.password_strong_level	
		},

		getLanguageSelected() {
			return this.$getLanguage(this.languages, this.id_user_language_selected)
		},

		passwordHint() {
			if (this.password_strong_level === 'hard')
				return `${this.$t(
					'your_password_must_contain_at_least_characters_uppercase_letters_lowercase_letters_numbers_and_symbols',
					{ symbols: '(! @ # $% ˆ)' }
				)}`
			else if (this.password_strong_level === 'medium')
				return this.$t(
					'your_password_must_contain_at_least_characters_uppercase_letters_lowercase_letters_numbers'
				)
			else return this.$t('your_password_must_contain_at_least_characters')
		},

		changeContainerHeight() {
			if (this.$q.screen.height < 950) return 'height-80'
			else return 'height-70'
		},
	},

	methods: {
		async fetchConfig() {
			const res = await axios.get('/clients/config/')
			
			this.config = res.data
		},

		setNewPassword() {
			this.v$.$touch()
			if (!this.v$.$error) {
				this.$q.loading.show()

				let fd = new FormData()
				fd.append('user_password', this.new_password)
				fd.append('user_password_confirmation', this.confirm_password)

				this.$axios
					.post(`/api_change_password/${this.uidb64}/${this.token}/`, fd)
					.then(() => {
						this.$q.loading.hide()

						this.$q.notify({
							message: this.$t('password_changed_successfully'),
							type: 'positive',
							icon: 'fal fa-check',
						})

						this.$mitt.emit('forceLogin', {
							username: this.username,
							password: this.new_password,
						})

						this.$router.replace({ name: 'login' })
					})
					.catch((error) => {
						if (
							error.response.status == 401 &&
							error.response.data.error == 'Token inválido'
						) {
							this.$q.notify({
								message: this.$t('the_password_reset_link_is_invalid'),
								type: 'negative',
								icon: 'fal fa-ban',
							})
						} else {
							this.$q.notify({
								message: this.$t('error_setting_new_password'),
								type: 'negative',
								icon: 'fal fa-ban',
							})
						}

						this.$q.loading.hide()
					})
			}
		},

		validPassword() {
			var hardRegex = new RegExp(
				'^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})'
			)
			var mediumRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})')
			var low = new RegExp('^(?=.{6,})')

			if (this.password_strong_level == 'hard') return hardRegex.test(this.new_password)
			else if (this.password_strong_level == 'medium')
				return mediumRegex.test(this.new_password)
			else return low.test(this.new_password)
		},

		backButton() {
			if (!this.use_portfolio_page) this.$router.push({ name: 'login' })
			else this.$router.push({ name: 'portfolio' })
		},
	},

	created() {
		this.fetchConfig()
		this.getLanguageSelected
		this.uidb64 = this.$route.params.uidb64
		this.token = this.$route.params.token
		this.username = this.$route.params.username
		if (this.$route.query && this.$route.query.redirect_to) {
			this.$store.dispatch('redirect/SET_REDIRECT', [
				this.$route.query.redirect_to.slice(2, -2),
			])
		}
		if (!this.uidb64 || !this.token || !this.username) this.$router.push({ name: 'login' })
	},

	validations() {
		return {
			new_password: {
				required,
				validPassword() {
					return this.validPassword()
				},
			},
			confirm_password: { sameAsPassword: sameAs(this.new_password) },
		}
	},
}
</script>

<style lang="scss" scoped>
.container-login {
	margin-top: 5%;
	margin-bottom: 5%;
}
.title {
	display: flex;
	justify-content: space-between;
}
</style>